<template>
  <div class="admin-role">
    <commonTable tableHead="role" @button-click="addRole" :config="{nothing}" :apiUrl="{url:'role',methods:'getRoleList'}" ref="commonTable" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="$permission(['角色管理-删除角色','角色管理-更新角色'])">
      <template #table_head>
        <div class="search-params">
          <wf-button type="primary" icon="icon iconfont iconicon_enlarge" @click="addRole" v-permission="'角色管理-新增角色'">新增角色</wf-button>
          <el-input prefix-icon="icon iconfont iconicon_search1" v-model="ruleForm.keyword" placeholder="搜索角色名称" clearable @keyup.enter.native="getRoleList" @input="getRoleList"></el-input>
        </div>
      </template>
      <template slot="verifyRemark" slot-scope="dataset">
        <span @click="edit(dataset.data.role_name)" v-permission="'角色管理-更新角色'">编辑</span>
        <span @click="del(dataset.data)" v-permission="'角色管理-删除角色'" v-if="dataset.data.delete_permission">删除</span>
      </template>
    </commonTable>
    <editRole v-if="paramsSet.dialogVisible" v-model="paramsSet.dialogVisible" :title="title" :paramsSet="paramsSet" @close="paramsSet.dialogVisible = false" @complete="complete" />
    <delRole v-model="userShow" :tableData="tableData" @close="userShow = false" @complete="delRolecomplate" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import basiCcontainer from "@/layouts/app/components/basiCcontainer";
import api from "@/services/api/role/role"
import editRole from './editRole'
import delRole from './roleUser'
export default {
  components: {
    basiCcontainer,
    editRole,
    delRole
  },
  data() {
    return {
      ruleForm: {},
      title: '新增角色',
      userShow: false,
      tableData: [],
      paramsSet: {
        dialogVisible: false,
        isEdit: false,
        editData: {}
      },
      nothing: {
        tip: '暂无角色信息',
        type: 'img_add_task',
        btnText: '新增角色',
        permission: '角色管理-新增角色'
      },
      timer: null
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$refs.commonTable.getTableList()
    },
    getRoleList() {
      this.debounce(this.init, 300)
    },
    findTask() {

    },
    addRole() {
      this.paramsSet = {
        editData: '',
        isEdit: false,
        dialogVisible: true
      }
      this.title = '新增角色'
    },
    async edit(role_name) {
      this.title = '编辑角色'
      await api.roleDetail({ role_name }).then(res => {
        this.editData = JSON.parse(JSON.stringify(res))
        this.paramsSet = {
          editData: JSON.parse(JSON.stringify(res)),
          isEdit: true,
          dialogVisible: true,
          edit_role_name_permission: res.edit_role_name_permission
        }
      }).catch(err => { })
    },
    del(data) {
      api.roleDetail({ role_name: data.role_name }).then(res => {
        if (res.users.length > 0) {
          this.tableData = JSON.parse(JSON.stringify(res))
          this.userShow = true
        } else {
          this.actionDel(data)
        }
      })
    },
    async actionDel(data) {
      await this.$wfAlert('warning', '确定删除该角色?')
      await api.deleteRole({ role_name: data.role_name })
      this.$message({ type: 'success', message: '删除成功!' });
      this.init()
    },
    delRolecomplate() {
      this.userShow = false
      this.actionDel()
    },
    complete() {
      this.paramsSet.dialogVisible = false
      this.init()
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.admin-role {
  // padding:30px;
  padding: 0 40px;
  overflow: hidden;
  height: 100%;
  .el-cascader {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .block {
    margin-top: 30px;
  }
  .el-form {
    height: 50px;
    line-height: 50px;
  }
  .el-form-item {
    margin: 0;
    display: inline-block;
  }
  .search-params {
    display: flex;
    justify-content: space-between;
    padding: 24px 0;
    .el-input {
      width: 360px;
    }
  }
}
</style>
